import { z } from "zod";
import { SKILL_TYPES, SKILL_STATUSES } from "../constants.js";
export const createSkillCatalogueSchema = z.object({
    name: z.string().min(1).max(100),
    displayName: z.string().max(100).optional(),
    description: z.string().max(1000).optional(),
    icon: z.string().max(50).optional(),
    contentMd: z.string().max(50000).optional(),
    requiredMcps: z.array(z.string()).optional(),
    parametersSchema: z.record(z.unknown()).optional(),
    skillType: z.enum(SKILL_TYPES).optional(),
    version: z.string().max(20).optional(),
});
export const updateSkillCatalogueSchema = z.object({
    name: z.string().min(1).max(100).optional(),
    displayName: z.string().max(100).nullable().optional(),
    description: z.string().max(1000).nullable().optional(),
    icon: z.string().max(50).nullable().optional(),
    contentMd: z.string().max(50000).nullable().optional(),
    requiredMcps: z.array(z.string()).nullable().optional(),
    parametersSchema: z.record(z.unknown()).nullable().optional(),
    skillType: z.enum(SKILL_TYPES).optional(),
    status: z.enum(SKILL_STATUSES).optional(),
    version: z.string().max(20).nullable().optional(),
});
export const assignTenantSkillSchema = z.object({
    companyId: z.string().uuid(),
    catalogueSkillId: z.string().uuid(),
    name: z.string().min(1).max(100).optional(),
    customContentMd: z.string().max(50000).optional(),
    parameterValues: z.record(z.unknown()).optional(),
});
export const updateTenantSkillSchema = z.object({
    name: z.string().min(1).max(100).optional(),
    customContentMd: z.string().max(50000).nullable().optional(),
    parameterValues: z.record(z.unknown()).nullable().optional(),
    enabled: z.boolean().optional(),
    /**
     * "agent" (default) — only loaded by agents with an explicit assignment.
     * "global" — auto-loaded by every agent in the company.
     * Flipping to "global" triggers an eager fan-out syncSkills across the
     * tenant; flipping back removes the file from each agent's workspace
     * on the next sync.
     */
    scope: z.enum(["agent", "global"]).optional(),
});
export const assignAgentSkillSchema = z.object({
    agentId: z.string().uuid(),
    tenantSkillId: z.string().uuid(),
    parameterOverrides: z.record(z.unknown()).optional(),
});
export const updateAgentSkillSchema = z.object({
    parameterOverrides: z.record(z.unknown()).nullable().optional(),
    enabled: z.boolean().optional(),
});
//# sourceMappingURL=skill.js.map